import { HTMLAttributes, forwardRef } from 'react';
import { cn } from '../../lib/cn';

export interface SectionProps extends HTMLAttributes<HTMLElement> {
  spacing?: 'none' | 'sm' | 'md' | 'lg';
  background?: 'white' | 'neutral' | 'gradient';
}

export const Section = forwardRef<HTMLElement, SectionProps>(
  (
    { className, spacing = 'md', background = 'white', children, ...props },
    ref
  ) => {
    const spacings = {
      none: '',
      sm: 'section-padding-sm',
      md: 'section-padding',
      lg: 'section-padding-lg',
    };

    const backgrounds = {
      white: 'bg-white',
      neutral: 'bg-neutral-50',
      gradient: 'bg-gradient-wellness',
    };

    return (
      <section
        ref={ref}
        className={cn(spacings[spacing], backgrounds[background], className)}
        {...props}
      >
        {children}
      </section>
    );
  }
);

Section.displayName = 'Section';
